import React, { useState } from 'react';
import { sanitizeManualPhone } from '../../pages/conversations.utils.ts';

interface NewMessageModalProps {
  open: boolean;
  onClose: () => void;
  onSend: (data: { telefone: string; nome: string; mensagem: string }) => Promise<void>;
}

const NewMessageModal: React.FC<NewMessageModalProps> = ({ open, onClose, onSend }) => {
  const [telefone, setTelefone] = useState('');
  const [nome, setNome] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [error, setError] = useState('');

  const handleSend = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const telefoneNormalizado = sanitizeManualPhone(telefone);

      await onSend({
        telefone: telefoneNormalizado,
        nome: nome.trim(),
        mensagem: mensagem.trim()
      });
      setTelefone('');
      setNome('');
      setMensagem('');
      setError('');
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro desconhecido');
    }
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
      <form
        className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm"
        onSubmit={handleSend}
      >
        <h2 className="font-bold text-lg mb-2">Nova Mensagem</h2>
        <input
          type="tel"
          required
          pattern="\d{10,13}"
          maxLength={13}
          value={telefone}
          onChange={e => setTelefone(e.target.value)}
          placeholder="DDD + número, ex: 11988887777"
          className="w-full border p-2 mb-2 rounded"
        />
        <input
          type="text"
          value={nome}
          onChange={e => setNome(e.target.value)}
          placeholder="Nome (opcional)"
          className="w-full border p-2 mb-2 rounded"
        />
        <textarea
          required
          value={mensagem}
          onChange={e => setMensagem(e.target.value)}
          placeholder="Digite sua mensagem"
          className="w-full border p-2 mb-2 rounded"
        />
        {error && <div className="text-red-600 text-sm mb-1">{error}</div>}
        <div className="flex gap-2 mt-3">
          <button type="submit" className="flex-1 bg-[#2f7d72] text-white py-2 rounded hover:bg-[#27685f] transition">Enviar</button>
          <button type="button" className="flex-1 bg-gray-200 text-gray-700 py-2 rounded" onClick={onClose}>Cancelar</button>
        </div>
      </form>
    </div>
  );
};

export default NewMessageModal;
